import { useEffect } from "react";
import { useAuthenticationPrecificador } from "application/routes/hooks/useAuthentication";
import Layout from "../../components/Layout";

import { setSidebarOpen } from "providers/reducers/header";
import { setSubscription } from "providers/reducers/user";
import { useSelector, useDispatch } from "react-redux";
import { Title } from "../../styled-components";

import { useHistory } from "react-router-dom";

export const RegrasPrecificador = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const regex = /[?&]subscription_id=([^&#]*)/;
  const match = regex.exec(history.location.search);
  const subscription_id = match && match[1];
  dispatch(setSubscription(subscription_id));

  let expanded = useSelector((state) => state.header.sidebarOpen);
  const userDataState = useSelector((state) => state.user);
  const sidebar = useSelector((state) => state.sidebar);

  function handleSidebar(state) {
    dispatch(setSidebarOpen(state));
  }

  useAuthenticationPrecificador(userDataState)
  useEffect(() => {
    if (!userDataState.user_profile_permissions.includes("READ")) {
      history.push("/?unauthorized_access");
    }
  });

  return (
    <Layout
      expanded={expanded}
      setExpanded={handleSidebar}
      username={userDataState.user_name}
      sidebarOptions={JSON.parse(sidebar.pages)}
      position={"relative"}
      height={"100%"}
      mobileWidth={"100%"}
      mobileMargin={"61px 0 0 0"}
    >
      <Title>Regras - Consulta de Valores</Title>
      
    </Layout>
  );
}
